<template>
  <b-card>
    <navigation-link-form
      v-if="navigationLink"
      :key="navigationLink.id"
      @onSubmit="handleSubmit"
      :navigation-links="navigationLinks"
      :navigation-link="navigationLink"
      :is-editing="true" />
  </b-card>
</template>

<script>
import NavigationLinkForm from '@/components/navigation-management/NavigationLinkForm';
import NotificationMixin from '@/mixins/NotificationMixin';
import { all, show, update } from '@/http/navigation-management';

export default {
  mixins: [NotificationMixin],

  components: {
    NavigationLinkForm,
  },

  data() {
    return {
      navigationLinks: [],
      navigationLink: null,
    };
  },

  async created() {
    await this.fetchData();
  },

  watch: {
    '$route.params.id'() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      await Promise.all([this.fetchNavigationLinks(), this.fetchNavigationLink()]);
    },

    async fetchNavigationLinks() {
      try {
        const { data } = await all();
        this.navigationLinks = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem linków nawigacji. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    async fetchNavigationLink() {
      try {
        const { data } = await show(this.$route.params.id);
        this.navigationLink = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem linku nawigacji. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    async handleSubmit(formData) {
      try {
        await update(this.$route.params.id, formData);
        this.showSuccessNotification('Dane zostały zapisane', 'Link nawigacji został zaktualizowany.');
        this.$router.push({ name: 'navigation-management-index' });
      } catch (error) {
        const message =
          error.response?.data?.message ??
          'Wystąpił problem z edycją linku nawigacji. Skontaktuj się ze swoim developerem.';
        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
